import React from 'react';

const ProgressTab = ({ 
  loading, 
  error, 
  userData, 
  onRetry,
  onPracticeClick,
  getMindStreamIcon,
  getMindStreamColor
}) => {
  if (loading) {
    return (
      <div className="emit-loading">
        <div className="emit-loading-dot"></div>
        <div className="emit-loading-dot"></div>
        <div className="emit-loading-dot"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="emit-card" style={{ textAlign: 'center', color: '#e74c3c' }}>
        <h3>⚠️ Error Loading Data</h3>
        <p>{error}</p>
        <button onClick={onRetry} className="btn btn-primary mt-3">
          Retry
        </button>
      </div>
    );
  }

  // Calculate total time
  const totalMinutes = userData?.mindstreams?.reduce((sum, s) => sum + (s.time_minutes || 0), 0) || 0;
  const totalHours = (totalMinutes / 60).toFixed(1);

  return (
    <div className="emit-chat-container">
      {/* Link to Journey Dashboard */}
      <div className="emit-card" style={{ 
        marginBottom: '24px', 
        background: 'linear-gradient(135deg, rgba(102, 126, 234, 0.1), rgba(118, 75, 162, 0.1))',
        border: '1px solid rgba(102, 126, 234, 0.3)'
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <h3 style={{ margin: '0 0 4px 0', color: '#4A5568', fontSize: '1rem', fontWeight: '600' }}>
              📊 Full Progress Dashboard
            </h3>
            <p style={{ margin: '0', fontSize: '0.875rem', color: '#4A5568' }}>
              View milestones, points, streaks & transformation journey
            </p>
          </div>
          <a 
            href="/journey" 
            style={{
              background: 'linear-gradient(135deg, #667eea, #764ba2)',
              color: 'white',
              padding: '10px 20px',
              borderRadius: '8px',
              textDecoration: 'none',
              fontWeight: '600',
              fontSize: '0.875rem'
            }}
          >
            My Journey →
          </a>
        </div>
      </div>

      {/* Total Time Invested */}
      <div className="emit-card" style={{ textAlign: 'center', marginBottom: '24px' }}>
        <h2 style={{ margin: '0 0 8px 0', color: 'var(--primary-blue)' }}>
          ⏱️ {totalHours} hours
        </h2>
        <p style={{ margin: '0', color: '#4A5568', fontSize: '0.875rem' }}>
          Total Time Invested ({totalMinutes} minutes)
        </p>
      </div>

      {/* Recent Practices */}
      <div className="emit-card">
        <h3 style={{ marginBottom: '16px', color: 'var(--deep-blue)' }}>
          📖 Recent Practices
        </h3>
        {userData?.recent_practices && userData.recent_practices.length > 0 ? (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            {userData.recent_practices.slice(0, 10).map((practice, idx) => (
              <div 
                key={idx}
                onClick={() => onPracticeClick(practice)}
                style={{
                  padding: '14px',
                  background: 'rgba(74, 144, 226, 0.05)',
                  borderRadius: '10px',
                  borderLeft: `4px solid ${getMindStreamColor(practice.mindstream_type)}`,
                  cursor: 'pointer',
                  transition: 'all 0.2s ease'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-2px)';
                  e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)';
                  e.currentTarget.style.background = 'rgba(74, 144, 226, 0.1)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = 'none';
                  e.currentTarget.style.background = 'rgba(74, 144, 226, 0.05)';
                }}
              >
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <div>
                    <div style={{ fontWeight: '600', color: 'var(--deep-blue)', marginBottom: '4px' }}>
                      {practice.practice_type}
                    </div>
                    <div style={{ 
                      fontSize: '0.75rem', 
                      color: getMindStreamColor(practice.mindstream_type),
                      fontWeight: '500',
                      textTransform: 'capitalize'
                    }}>
                      {practice.mindstream_type} MindStream
                    </div>
                  </div>
                  <div style={{ textAlign: 'right' }}>
                    <div style={{ fontSize: '0.875rem', color: '#4A5568' }}>
                      {practice.duration_minutes}min
                    </div>
                    <div style={{ fontSize: '0.875rem', fontWeight: '600', color: practice.impact_score >= 8 ? '#10b981' : practice.impact_score >= 5 ? '#f59e0b' : '#ef4444' }}>
                      {practice.impact_score}/10
                    </div>
                  </div>
                </div>
                <div style={{ 
                  marginTop: '8px',
                  fontSize: '0.75rem',
                  color: '#4A5568',
                  fontStyle: 'italic'
                }}>
                  💡 Click to view insights
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div style={{ textAlign: 'center', padding: '30px', color: '#4A5568' }}>
            <div style={{ fontSize: '2rem', marginBottom: '12px' }}>📝</div>
            <p>No practices logged yet.</p>
            <p style={{ fontSize: '0.875rem' }}>Log your first practice to see it here!</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProgressTab;
